export const defaultLocale = "en";
export const localeOptions = [
  { id: "en", name: "English LTR", direction: "ltr" },
  { id: "es", name: "Español", direction: "ltr" },
  { id: "enrtl", name: "English RTL", direction: "rtl" }
];

// TODO: for demonstration only, text strings will be migrated to internationalization
export const FPI_S = "FPI";
export const FIRST_DATA_S = "First Data";
export const AVERAGE_DAYS_S = "Average Days";
export const TL_FPI_LABEL = "Site Active to FPI";
export const TL_FIRST_DATA_LABEL = "Site Active to First Data";
export const SHOW_TOP_WITHDRAW_PARTICIPANT = 10;
export const WITHDRAW_STUDY_PREFIX = "withdrawal";
const activityStatus = {};
activityStatus["Complete"] = 1;
activityStatus["Upcoming"] = 2;
activityStatus["Incomplete"] = 0;
export const ACTIVITY_STATUS = activityStatus;
const studyActivityStatus = {};
studyActivityStatus["Complete"] = 1;
studyActivityStatus["Upcoming"] = 2;
studyActivityStatus["Ongoing"] = 3;
studyActivityStatus["Incomplete"] = 0;
export const STUDY_ACTIVITY_STATUS = studyActivityStatus;
export const ACTIVITIES = "Activities";
export const SITES = "Sites";
export const COUNTRIES = "Countries";
export const PARTICIPANTS = "Participants";
export const PARTICIPANTSTATUS = "Participant Status";
export const TOTALDEVICE = "Total";
export const COLOR_MAPPING = {
  ACTIVE: "#7f69d4",
  DISQUALIFIED: "#fb9a99",
  INVITED: "#b9dfd1",
  ACTIVEWMODIFICATION: "#b269d4",
  IMPORTED: "#4240b6",
  VERIFIED: "#d6b2ce",
  REGISTERED: "#a6cee3",
  SCREENPASSED: "#84a5c3",
  PRESCREENED: "#7893f3",
  SCREENFAILED: "#fda26f",
  WITHDRAWSTUDY: "#fdbf6f",
  DISCONTINUED: "#fb9a99"
};
export const DEVICE_MAPPING = {
  IOSPHONE: "IOSPhone",
  IOSTABLET: "IOSTablet",
  ANDROIDPHONE: "AndroidPhone",
  ANDROIDTABLET: "AndroidTablet"
};
export const SCREENWIDTH = screen.width;
